import styled from 'styled-components/macro';

export const ItemGrid = styled('div')`
  .item-grid {
    display: flex;
    flex-wrap: wrap;
    margin-right: -15px;

    .item-container-wrapper {
      box-shadow: 0px 2px 4px 0px rgb(10, 32, 83, 0.07);
      border: 1px solid  rgb(10, 32, 83, 0.09);
      transition: all 0.3s ease;
      &:hover {
        box-shadow: 0px 8px 20px 0px rgb(10, 32, 83, 0.15);
      }
    }
    .wrap  {
      max-width: 25%;
    }
    @media(max-width: 1100px) {
      .wrap  {
        max-width: 33.3333%;
      }
    }
    @media(max-width: 800px) {
      margin-right: -6px;
      .wrap  {
        max-width: 50%;
        padding-right: 10px !important;
        .product-image, .product-image-container {
          height: 140px;
        }
        .product-content h2 {
          font-size: 18px !important;
          line-height: 25px !important;
        }
      }
    }
  }
`;

